import { useMemo } from 'react';

import { AGE_BUCKET_OPTIONS } from '../../../dto/openInvoice';

export default function useOpenInvoiceMetrics(invoices) {
    const totalsByBucket = useMemo(() => {
        const result = {};
        for (const option of AGE_BUCKET_OPTIONS) {
            result[option.value] = 0;
        }
        for (const inv of invoices) {
            if (!inv?.ageBucket) continue;
            const key = inv.ageBucket;
            const amount = Number(inv?.outstandingAmount ?? 0);
            result[key] = (result[key] || 0) + amount;
        }
        return result;
    }, [invoices]);

    const pieData = useMemo(() => (
        AGE_BUCKET_OPTIONS
            .map((option) => ({
                color: option.color,
                label: option.label,
                value: totalsByBucket[option.value] ?? 0,
            }))
            .filter((entry) => entry.value > 0)
    ), [totalsByBucket]);

    const totalOutstanding = useMemo(
        () => invoices.reduce((sum, inv) => sum + Number(inv?.outstandingAmount ?? 0), 0),
        [invoices]
    );

    return { totalsByBucket, pieData, totalOutstanding };
}
